export default __webpack_public_path__ + "static/media/eco_web_bg.eecf903d.mp4";